var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('Section',{attrs:{"limiter":"","hide":""}},[(_vm.pending)?_c('EmptyEntityCardsSlider'):_c('CategoriesComponent',{attrs:{"categories":_vm.categories}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }